module.exports = __webpack_public_path__ + "static/media/undraw_mindfulness_scgo.ff49a19e.svg";